export default __webpack_public_path__ + "static/media/singapore-online-education.0abd3c89.png";